import React, { useContext, useState, useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Button, FormControlLabel, Checkbox, FormLabel, FormControl, InputLabel, Select, Snackbar, Typography, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiAlert from '@material-ui/lab/Alert';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from "@material-ui/core/styles";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import 'date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { Context } from "../contexts/siteContext";
import { Modules } from '../contexts/modulesContext';
import { ResolutionComment } from '../contexts/resolutionCommentContext';
import { AssignedToUsers } from '../contexts/assignedToUsers';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '5px 0px',
            width: '100%'
        }
    },
    listIcon: {
        float: 'left',
        marginRight: '5px'
    },
    listIconRight: {
        marginLeft: '25px'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    }
}));

export default function UnsatDialog(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { modules } = useContext(Modules);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const { resolutions, getResolutions, comments, getComments } = useContext(ResolutionComment);
    const [showCoach, setShowCoach] = useState(true);
    const [coachDisabled, setCoachDisabled] = useState(true);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showOtherComment, setShowOtherComment] = useState('none');
    const [showAssignedDate, setShowAssignedDate] = useState('none');
    const [unsatData, setUnsatData] = useState({
        unsatisfactory: true,
        completed: false,
        confirmed: false,
        comment: [],
        otherComment: '',
        defaultManager: [],
        selectedResolution: '',
        assignedDate: ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite)
    });
    const currentTheme = props.currentTheme;

    const cancel = () => {
        props.parentCallback();
    }

    const closeSnackbar = () => {
        setOpen(false);
    };

    const isAuthorized = (title) => {
        if (modules !== undefined && modules.length > 0) {
            const index = modules.findIndex(item => item.title === title);
            return (index === -1) ? false : true;
        }
        else
            return false;
    };

    const loadData = () => {
        var data = props.UnsatRound;

        if (data.id !== -1 && data.comment !== null) {
            var comment = data.comment || [];
            var idxOfShortLine = comment.indexOf('-');
            var otherComment = '';
            var index = 0;

            if (idxOfShortLine > -1) {
                if (comment.indexOf("Other") === 0) {
                    comment = comment.substring(idxOfShortLine + 2, comment.length);
                    otherComment = comment;
                    index = comments.findIndex(x => x.name === "Other");
                    data.comment = comments.slice(index, index + 1);
                    setShowOtherComment(true);
                }
                else {
                    otherComment = comment;
                    comment = comment.substring(idxOfShortLine + 2, comment.length);
                    index = comments.findIndex(x => x.name === comment);
                    data.comment = comments.slice(index, index + 1);
                }
            }

            var managerIndex = assignedUsers.findIndex(x => x.id === data.assignedTo);
            var date;
            var stringRes = data.resolution || '';
            if (stringRes.indexOf("Assign To") > -1) {
                idxOfShortLine = stringRes.indexOf(':');
                date = stringRes.substring(idxOfShortLine + 1, stringRes.length);
                data.resolution = stringRes.substring(0, idxOfShortLine);
                setShowAssignedDate(true);
            }
            else {
                date = ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite);
            }

            setUnsatData({
                ...unsatData,
                unsatisfactory: data.unsatisfactory,
                completed: data.completed,
                confirmed: data.managerConfirmed,
                comment: data.comment,
                otherComment: otherComment,
                defaultManager: managerIndex > -1 ? assignedUsers.slice(managerIndex, managerIndex + 1) : [],
                selectedResolution: data.resolution,
                assignedDate: date
            });
        }
    };

    const checkUnsatisfied = (e) => {
        setUnsatData({
            ...unsatData,
            unsatisfactory: e.target.checked,
            completed: false,
            confirmed: false
        })
    };

    const checkCompleted = (e) => {
        if (!e.target.checked)
            setUnsatData({ ...unsatData, completed: e.target.checked, confirmed: false });
        else
            setUnsatData({ ...unsatData, completed: e.target.checked });
        if (!unsatData.unsatisfactory)
            setUnsatData({ ...unsatData, completed: false });
    };

    const checkConfirmed = (e) => {
        if (e.target.checked)
            setUnsatData({ ...unsatData, confirmed: e.target.checked, completed: true });
        else
            setUnsatData({ ...unsatData, confirmed: e.target.checked });
        if (!unsatData.unsatisfactory)
            setUnsatData({ ...unsatData, confirmed: false });
    };

    const commentChanged = (selectedOptions) => {
        setUnsatData({ ...unsatData, comment: selectedOptions });

        if (selectedOptions.length > 0) {
            if (selectedOptions[0].name === "Other") {
                setUnsatData({ ...unsatData, otherComment: '', comment: selectedOptions });
                setShowOtherComment('flex');
            }
            else if (selectedOptions[0].pid > 0) {
                setShowOtherComment('none');
                var index = comments.findIndex(x => x.name === selectedOptions[0].name);
                var pid = comments[index].pid;
                var fullComment = comments[comments.findIndex(x => x.id === pid)].name + " - " + selectedOptions[0].name;
                setUnsatData({ ...unsatData, comment: selectedOptions, otherComment: fullComment });
            }
            else {
                setUnsatData({ ...unsatData, comment: [] });
            }
        }
    };

    const resolutionChanged = (e) => {
        setUnsatData({ ...unsatData, selectedResolution: e.target.value });
        if (e.target.value === "Assign To") {
            setShowAssignedDate('flex');
        }
        else {
            setShowAssignedDate('none');
        }
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY");
        setUnsatData({ ...unsatData, assignedDate: date });
    };

    const managerChanged = (value) => {
        setUnsatData({ ...unsatData, defaultManager: value });
    };

    const validate = () => {
        let message = "";

        if (unsatData.unsatisfactory === false) {
            message = "Please check the Unsatisfactory.";
        }
        else if (unsatData.comment.length === 0) {
            message = "Please select the Comment.";
        }
        else if (unsatData.selectedResolution === '') {
            message = "Please select the Resolution.";
        }
        else if (unsatData.selectedResolution === 'Assign To' && unsatData.assignedDate === "Invalid date") {
            message = "Please select the valid date.";
        }
        else if (unsatData.defaultManager.length === 0) {
            message = "Please select the Assigned to.";
        }

        if (message !== "") {
            setErrorMessage(message);
            setOpen(true);
            return false;
        }
        else
            return true;
    }

    const unsatSave = (showCoach) => {
        if (validate()) {
            TransactionTime.end();
            TransactionTime.updateData(unsatData);
            props.onSave(unsatData, showCoach);
            props.onCloseDialog();
        }
    };

    useEffect(() => {
        if (assignedUsers.length === 0 || assignedUsers[0].uniBrief !== defaultSite.houseCode.toString()) getAssignedToUsers();
        if (resolutions.length === 0) getResolutions();
        if (comments.length === 0) getComments();
        if (props.UnsatRound.id === -1) {
            TransactionTime.begin('Round');
        }
        if (!isAuthorized('Coach') || defaultSite.IntegratedSystem.TeamCoachId === null || defaultSite.IntegratedSystem.TeamCoachId === "0") {
            setShowCoach(false);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (assignedUsers.length > 0 && comments.length > 0 && resolutions.length > 0) {
            loadData();
        }
        // eslint-disable-next-line
    }, [assignedUsers, comments, resolutions]);

    useEffect(() => {
        let isCoachDisabled = false;
        if (sessionStorage.getItem("isOffline") === "1" || !unsatData.unsatisfactory || unsatData.comment.length === 0 || unsatData.defaultManager.length === 0 || unsatData.selectedResolution === "")
            isCoachDisabled = true;
        setCoachDisabled(isCoachDisabled);
        // eslint-disable-next-line
    }, [unsatData.unsatisfactory, unsatData.comment, unsatData.defaultManager, unsatData.selectedResolution]);

    return (
        <div>
            <Snackbar open={open} autoHideDuration={3000} onClose={closeSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Dialog maxWidth='md' open={props.openDialog} onClose={props.onCloseDialog} fullWidth={true} aria-labelledby="max-width-dialog-title" disableBackdropClick={true}>
                <MuiDialogTitle disableTypography style={{ display: 'flex', flexWrap: 'wrap',}}>
                    <Typography variant="h6">{(props.UnsatRound.id === -1) ? "Add" : "Edit"} Round</Typography>
                    {props.openDialog ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={props.onCloseDialog}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </MuiDialogTitle>
                <DialogContent className={classes.root} style={{ height: '500px' }} dividers>
                    <DialogContentText style={{ marginBottom: '0px' }}>
                        <FormLabel style={{ color: currentTheme.secondary }}>Location : {props.RoundLocation.name}</FormLabel>
                    </DialogContentText>
                    <FormControlLabel
                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                        value="start"
                        control={<Checkbox style={{ color: currentTheme.secondary }} checked={unsatData.unsatisfactory} />}
                        label="Unsatisfactory"
                        labelPlacement="start"
                        onChange={e => checkUnsatisfied(e)}
                    />
                    <br />
                    <Typeahead style={{ marginTop: '0px' }}
                        filterBy={(option, props) => {
                            // Display all the options if there's a selection.
                            return true;
                        }}
                        id="comment"
                        labelKey="name"
                        onChange={commentChanged}
                        options={comments}
                        placeholder="Choose a Comment..."
                        selected={unsatData.comment}
                        renderMenuItemChildren={(option, key) => (
                            <div className="dropdown-widget" >
                                {option.pid === 0 ? (
                                    <>
                                        <FormatListBulletedIcon fontSize="small" className={classes.listIcon} />
                                        <div className="left">{option.name}</div>
                                    </>)
                                    :
                                    <div className={classes.listIconRight}>{option.name}</div>
                                }
                            </div>
                        )}
                    />
                    <TextField style={{ width: '100%', marginTop: '10px', display: showOtherComment }}
                        label="Other Comment"
                        onChange={e => setUnsatData({ ...unsatData, otherComment: e.target.value })}
                        name="comment"
                        value={unsatData.otherComment}
                        variant="outlined"
                        size="small"
                    />
                    <FormControl variant="outlined" margin="dense" >
                        <InputLabel>Resolution</InputLabel>
                        <Select style={{ width: '100%', color: 'inherit' }}
                            native
                            label="Resolution"
                            size="small"
                            value={unsatData.selectedResolution}
                            onChange={resolutionChanged}
                        >
                            <option aria-label="None" key="0" value="" />
                            {
                                resolutions.map((option, key) => {
                                    return <option key={option.id} value={option.name} label={option.name} >{option.name}</option>;
                                })
                            }
                        </Select>
                    </FormControl>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker autoOk
                            style={{ display: showAssignedDate, marginTop: '5px' }}
                            inputVariant="outlined"
                            label="Date"
                            format="MM/dd/yyyy"
                            size="small"
                            value={unsatData.assignedDate}
                            InputAdornmentProps={{ position: "start" }}
                            onChange={date => dateChanged(date)}
                        />
                    </MuiPickersUtilsProvider>
                    <Typeahead
                        style={{ width: 'auto', marginTop: '5px', color: 'inherit' }}
                        id="assignedTo"
                        labelKey={(option) => `${option.firstName} ${option.lastName}`}
                        onChange={managerChanged}
                        options={assignedUsers}
                        placeholder="Choose a Manager..."
                        selected={unsatData.defaultManager}
                        renderMenuItemChildren={(option, key) => (
                            <div className="dropdown-widget">
                                <div className="left">{option.firstName} {option.lastName}</div>
                            </div>
                        )}
                     />
                    <FormControlLabel
                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                        value="start"
                        control={<Checkbox style={{ color: currentTheme.secondary }} checked={unsatData.completed} />}
                        label="Completed"
                        labelPlacement="start"
                        onChange={e => checkCompleted(e)}
                    />
                    <br />
                    <FormControlLabel
                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                        value="start"
                        control={<Checkbox style={{ color: currentTheme.secondary }} checked={unsatData.confirmed} />}
                        label="Manager Confirmed"
                        labelPlacement="start"
                        onChange={e => checkConfirmed(e)}
                    />
                </DialogContent>
                <DialogActions>
                    <div style={{ flex: 'auto' }}>
                        {showCoach &&
                            <Button variant="contained"
                                color="primary"
                                size="small"
                                style={{ background: currentTheme.secondary, width: "100px", marginLeft: "20px" }}
                                disabled={coachDisabled}
                                onClick={e => unsatSave(true)}
                            >
                                Coach
                            </Button>
                        }
                        <Button variant="contained" disabled style={{ display: 'none', background: currentTheme.primary, width: 'auto', color:'white' }}>
                            Create Task
                        </Button>
                    </div>
                    <Button variant="contained"
                        color="primary"
                        size="small"
                        style={{ background: currentTheme.secondary, width: "100px" }}
                        startIcon={<SaveIcon />}
                        onClick={e => unsatSave(false)}
                    >
                        Save
                    </Button>
                    <Button variant="contained"
                        color="secondary"
                        size="small"
                        style={{ width: "100px", marginRight: "20px" }}
                        startIcon={<CancelIcon />}
                        onClick={props.onCloseDialog}
                        autoFocus
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {(props.UnsatRound.id === -1) && (
                <InactiveTimeout disContinue={cancel} />
            )}
        </div>
    );
}
